import TradePage from "./TradePage";
import { trades } from "@/data/trades";

export default function Electricians() {
  return <TradePage trade={trades.electricians} />;
}
